import React from "react";
import { Box, Skeleton } from "@mui/material";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const iconLinkStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  backgroundColor: "rgba(249, 249, 252, 1)",
  color: "rgba(36, 139, 112, 1)",
  transition: "background-color 0.2s",
  "&:hover": {
    backgroundColor: "rgba(242, 243, 251, 1)",
  },
};

/**
 * Inline contact icons row for "CM / Supplier contact information" CTAs:
 * whatsapp, phone, email — showing only whatever is available.
 */
function ContactInfoIcons({ contactInfo, isLoading }) {
  if (isLoading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="circular" width={28} height={28} />
      </Box>
    );
  }

  if (!contactInfo) return null;

  const whatsappNumber = contactInfo.whatsapp || contactInfo.phone;
  const hasAny = whatsappNumber || contactInfo.phone || contactInfo.email;
  if (!hasAny) return null;

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: "12px" }}
      onClick={(e) => e.stopPropagation()}
    >
      {whatsappNumber && (
        <Box
          component="a"
          href={`https://api.whatsapp.com/send/?phone=${whatsappNumber.replace(/[^0-9]/g, "")}`}
          target="_blank"
          rel="noopener noreferrer"
          title="WhatsApp"
          sx={iconLinkStyles}
        >
          <WhatsAppIcon sx={{ fontSize: "16px" }} />
        </Box>
      )}
      {contactInfo.phone && (
        <Box
          component="a"
          href={`tel:${contactInfo.phone}`}
          title="Phone"
          sx={iconLinkStyles}
        >
          <PhoneOutlinedIcon sx={{ fontSize: "16px" }} />
        </Box>
      )}
      {contactInfo.email && (
        <Box
          component="a"
          href={`mailto:${contactInfo.email}`}
          title="Email"
          sx={iconLinkStyles}
        >
          <MailOutlineIcon sx={{ fontSize: "16px" }} />
        </Box>
      )}
    </Box>
  );
}

export default ContactInfoIcons;
